import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import ObraVinculoSapRepository from '@/shared/http/repositories/business/obraVinculoSap'
import OcorrenciaCasaRepository from '@/shared/http/repositories/realestate/ocorrenciaCasa'
import { loading, toast } from '@/shared/utils/UIHelper'
import dataform from './ocorrencia'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import localStoreHelper from '@/shared/utils/localStoreHelper'

export default {
  name: 'tableocurrence',
  mixins: [AccountMixin, CompanyMixin, PermissionMixin, ActionsForm],
  components: {HeadDetailsGama},
  data () {
    return {
      columns: ['CÓDIGO', 'NOME MORADOR', 'EMPREENDIMENTOS', 'UNIDADE', 'STATUS', 'DATA DO CHAMADO', 'DATA DA AVALIAÇÃO TÉCNICA', 'DATA PREVISTA TÉRMINO', 'DATA DE TÉRMINO DO ATENDIMENTO', 'ENGENHEIRO RESPONSÁVEL', ''],
      dataOcorrencia: [],
      dataSearch: localStoreHelper.controleOcorrencia.ocorrencias() || dataform,
      roles: Roles,
      // Unir com SAP direto da lista, sem precisar entrar nos Detalhes — mesmo padrão do sorting.js,
      // só que aqui guarda o id do chamado clicado (unir.ocorrenciaId) em vez de usar um dataDetails fixo.
      unir: {
        ocorrenciaId: null,
        empreendimentos: [],
        unidades: [],
        unidadesOptions: [],
        codEmp: null,
        casaIdx: null
      }
    }
  },
  mounted () {
    this.onload()
  },
  methods: {
    onload () {
      if (!this.hasRole(this.roles.RW_REAL_ESTA_USER_OBRA)) {
        this.dataSearch.typeAccess = false
      } else {
        this.dataSearch.typeAccess = true
      }
      loading.push()
      OcurrenceRepository.GetAll(this.dataSearch, this.typeaccess, this.$refs.tableocurrence.pagingLimit, this.$refs.tableocurrence.pagingIndex)
        .then(Response => {
          this.$refs.tableocurrence.LoadAllByData(Response)
          this.dataOcorrencia = Response.data.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    Details (data) {
      console.log(data)
    },
    Delete (data) {
      loading.push()
      OcurrenceRepository.Delete(data.id)
        .then((Response) => {
          loading.pop()
          this.onload()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    NextStatus (data) {
      loading.push()
      OcurrenceRepository.NextStatus(data.id)
        .then((Response) => {
          this.onload()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    abrirUnir (data) {
      this.unir.ocorrenciaId = data.id
      this.unir.codEmp = null
      this.unir.casaIdx = null
      this.unir.unidades = []
      this.unir.unidadesOptions = []
      loading.push()
      ObraVinculoSapRepository.GetEmpreendimentosSap()
        .then(response => {
          const respData = (response.data && response.data.data) ? response.data.data : []
          this.unir.empreendimentos = respData.map(e => ({ value: e.codEmp, text: e.empreendimento }))
          this.$refs.modalUnirSap.show()
        })
        .catch(err => { console.log(err); toast.error(this.$lang.Common.Alerts.Error) })
        .finally(() => loading.close())
    },
    onChangeEmpreendimento () {
      this.unir.casaIdx = null
      this.unir.unidades = []
      this.unir.unidadesOptions = []
      if (this.unir.codEmp === null) return
      loading.push()
      ObraVinculoSapRepository.GetUnidadesSap(this.unir.codEmp)
        .then(response => {
          this.unir.unidades = (response.data && response.data.data) ? response.data.data : []
          this.unir.unidadesOptions = this.unir.unidades.map((u, i) => ({
            value: i,
            text: `${u.quadra || ''} / ${u.unidade || ''}${u.jaVinculada ? ' (já unida)' : ''}`
          }))
        })
        .catch(err => { console.log(err); toast.error(this.$lang.Common.Alerts.Error) })
        .finally(() => loading.close())
    },
    confirmarUnir () {
      if (this.unir.casaIdx === null) return
      const casa = this.unir.unidades[this.unir.casaIdx]
      loading.push()
      ObraVinculoSapRepository.UnirCasa(casa)
        .then(response => {
          const vinculo = (response.data && response.data.data) ? response.data.data : null
          if (!vinculo || !vinculo.id) throw new Error('vínculo sem id')
          return OcorrenciaCasaRepository.Vincular(this.unir.ocorrenciaId, vinculo.id)
        })
        .then(() => {
          toast.success('Chamado unido à casa do SAP.')
          this.$refs.modalUnirSap.hide()
          this.onload()
        })
        .catch(err => { console.log(err); toast.error(this.$lang.Common.Alerts.Error) })
        .finally(() => loading.close())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/tableocurrence/tableocurrence.js